export default __webpack_public_path__ + "static/media/Hafsa Arshad.2d946464.jpeg";